import { SIGN_IN, SIGN_OUT } from "../actions/types";

const INITIAL_STATE = {
  isSignedIn: null,
  userId: null,
  userName: null,
  userGivenName: null,
  source: null
}

const userReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case SIGN_IN: 
      return { 
        ...state,
        isSignedIn: true,
        userId: action.payload.userId,
        userName: action.payload.userName,
        userGivenName: action.payload.userGivenName,
        source: action.payload.source,
      };
    case SIGN_OUT:
      return { 
        ...state,
        isSignedIn: false,
        userId: null,
        userName: null,
        userGivenName: null,
        source: null,
      };
    default: 
      return state;
  }
}

export default userReducer;